import { render } from "./DialoguesTab.vue?vue&type=template&id=18528830&scoped=true&ts=true"
import script from "./DialoguesTab.vue?vue&type=script&lang=ts"
export * from "./DialoguesTab.vue?vue&type=script&lang=ts"

import "./DialoguesTab.vue?vue&type=style&index=0&id=18528830&scoped=true&lang=css"

import exportComponent from "C:\\Ventla new admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18528830"]])

export default __exports__